import { render } from "./DiskTags.vue?vue&type=template&id=48fa62b5&scoped=true"
import script from "./DiskTags.vue?vue&type=script&lang=js"
export * from "./DiskTags.vue?vue&type=script&lang=js"

import "./DiskTags.vue?vue&type=style&index=0&id=48fa62b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fa62b5"]])

export default __exports__